// @flow
import { AnalyticsTypes, recordAnalyticsForSavedSearchesPageView } from '../../../redux/modules/analytics';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { sleep } from '../../../utils/sleep';

export default ({ store }: DataLoaderParams) => {
    const { dispatch } = store;
    return Promise.all([sleep(1500)]).then(() => {
        return dispatch(recordAnalyticsForSavedSearchesPageView(AnalyticsTypes.Page.SavedSearchRecent));
    });
};
